import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { filter } from 'rxjs';
import { IdentificacaoAtendimento } from 'src/app/models/Servico.model';
import { PesquisaAtendimentoForm } from 'src/app/models/pesquisa-atendimento.mode';
import { PesquisaServicoService } from 'src/app/services/pesquisa-servico.service';

@Component({
  selector: 'app-pesquisa-servico',
  templateUrl: './pesquisa-servico.component.html',
  styleUrls: ['./pesquisa-servico.component.css'],
})
export class PesquisaServicoComponent implements OnInit {
  form!: FormGroup;
  status: 'FORM' | 'LOADING' = 'LOADING';
  statusMessage: Message[] = [];
  loading = true;
  identificador!: IdentificacaoAtendimento;

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: PesquisaServicoService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .pipe(filter((data) => data.has('id') && data.has('hash')))
      .subscribe((params) => {
        const id = Number(params.get('id'));
        const hash = params.get('hash') || '';

        this.service.getIdentificadorPesquisa(id, hash).subscribe({
          next: (data) => {
            this.identificador = data;
            this.status = 'FORM';
            this.loading = false;
          },
          error: (error) => this._enviarError(error.error.message),
        });
      });

    this.form = this.fb.group({
      resposta_1: [null, [Validators.required]],
      resposta_2: [null, [Validators.required]],
    });
  }

  enviar() {
    this.loading = true;
    this.form.disable();

    const form = new PesquisaAtendimentoForm(
      this.identificador.id,
      this.identificador.hash,
      this.form.value['resposta_1'],
      this.form.value['resposta_2']
    );

    this.service.postPesquisa(form).subscribe({
      next: (_) => this._enviarPesquisaConcluida(),
      error: (error) => this._enviarError(error.error.message),
    });
  }

  _enviarPesquisaConcluida() {
    this.router.navigate([
      `servico/pesquisa/${this.identificador.id}/${this.identificador.ano}/concluida`,
    ]);
  }

  _enviarError(message: string) {
    this.router.navigate(['servico/pesquisa/error', { message: message }]);
  }
}
